import { render, staticRenderFns } from "./_sidebar.vue?vue&type=template&id=43ea33f6&scoped=true"
import script from "./_sidebar.vue?vue&type=script&lang=js"
export * from "./_sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ea33f6",
  null
  
)

export default component.exports